import { createStore } from "vuex";
import user from './modules/user';
import link from './modules/link'
import role from './modules/role'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({
    isCompression: false,
  });
const store={
    state(){
        return {
            
        }
    },
    getters:{
       
    },
    mutations:{

    },
    actions:{

    },
    modules:{
        user,
        link,
        role
    },plugins: [
        createPersistedState({
          
          key: "QrApp",
          storage: {
            getItem: (key) => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: (key) => ls.remove(key),
          },
        }),
      ],
}
export default createStore(store);